import { MathJaxLoader } from '../mathjax/config'

export const MathdownConfig = ({ children }: { children: React.ReactNode }) => {
  return <MathJaxLoader>{children}</MathJaxLoader>
}
